// Rounded panel used for stats, list rows and modal bodies.
// `tone` swaps the border color for error / success accents.
export default function Card({ tone = 'default', className = '', children, ...rest }) {
  const toneClass =
    tone === 'error'
      ? 'border-error'
      : tone === 'success'
        ? 'border-success'
        : 'border-border';

  return (
    <div
      className={`rounded-lg border bg-bg p-4 shadow-sm ${toneClass} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
